import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.js';
import React from 'react';
import { GlobalComponentsProvider } from './context/GlobalComponentsContext';
import DialogLayout from './components/customLayout/dialog';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalComponentsProvider>
      <DialogLayout />
      <App />
    </GlobalComponentsProvider>
  </StrictMode>,
);
